export const DJ_KEY = 'djKey';
export const DJ_COURT_SYSTEM_ID = 'djCsId';
export const DJ_REGION = 'djRegion';
export const UPDATE_STREAMING_SESSION_STATE_TOPIC_SUFFIX = 'update-streaming-session-state.fifo';
